(() => {
  angular
    .module('gm.common.directives')
    .directive('gmPhoneInputBox', gmPhoneInputBoxDirective);

  function gmPhoneInputBoxDirective(
    $filter,
    Countries,
    GmyPhone,
    btgUser
  ) {
    'ngInject';

    const countryList = Countries.filter(c => !!c.key).map(prepareCountryForDropdownMeny);

    function prepareCountryForDropdownMeny({ key, country, code }) {
      return {
        id: key.toUpperCase(),
        name: country,
        meta: `+${code}`,
        flag: key ? key.toLowerCase() : null,
        code
      };
    }

    return {
      replace: true,
      require: 'ngModel',
      restrict: 'E',
      scope: {
        gmDisabled: '=?',
        label: '@',
        placeholder: '@',
        readonly: '@?',
        tooltip: '@?',
        tooltipType: '@'
      },
      templateUrl: 'modules/common/directives/phone-input-box/phone-input-box.html',
      transclude: true,

      link(scope, _element, _attrs, ctrl) {
        scope.view = {
          filterInput: '',
          isOpen: false
        };

        scope.number = {
          nationalPart: '',
          prefix: ''
        };

        scope.filteredCountries = [];
        scope.$watch('view.filterInput', (filterInput) => {
          scope.filteredCountries = $filter('filter')(countryList, filterInput);
        });

        scope.toggleDropdown = ($event) => {
          if (_attrs.ngReadonly === 'true') {
            $event.preventDefault();

            return;
          }

          scope.view.isOpen = !scope.view.isOpen;

          if (!scope.view.isOpen) {
            $event.preventDefault();
          }
        };

        scope.selectCountry = (country) => {
          if (country) {
            scope.number.prefix = country.code;
            scope.number.flag = country.flag;
            scope.view.isOpen = false;
          }
        };

        const userCountry = btgUser.getProfile().countryCode;

        scope.selectCountry(countryList.find(country => country.id === userCountry));

        scope.$watchCollection('number', (number) => {
          if (number.nationalPart) {
            ctrl.$setViewValue(`+${number.prefix}${number.nationalPart}`);
          } else {
            ctrl.$setViewValue('');
          }
        });

        ctrl.$formatters.unshift((phone) => {
          const parsedNumber = GmyPhone.parsePhonenumber(phone);

          if (parsedNumber) {
            scope.number.nationalPart = parsedNumber.nationalNumber;
            scope.number.prefix = parsedNumber.prefix;
            scope.number.flag = parsedNumber.countryCode.toLowerCase();
          }
        });

        ctrl.$validators.validNumber = function validNumberParser(modelValue, viewValue) {
          const value = modelValue || viewValue;

          return !value || GmyPhone.isValidPhoneNumber(value);
        };
      },
    };
  }
})();
